import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-events-tab-1-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-events-tab-1.part.html',
})
export class DeliveryEventsTab1Part {
}
